import moment from "moment";
import { useState, useEffect, useCallback } from "react";
import { alertSuccess, alertError } from "../../../components/alert/swal";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
// import { RoutePath } from "../../../routes/Routes";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { STATUS_ENUM } from "../website-structure/content/enum/content.enum";
import { routeName } from "../../../routes/routeName";
import { bodyFormPoll, FormPollApi, poll_type_list_type } from "../../../api/form-poll/form_poll.api";
import { produce } from "immer";
import { FORM_POLL_CHOICE_TYPE } from "./enum/enum";

const initialErrorMessage = {
    content_start_date: "",
    content_end_time: "",
    content_name: "",
    content_start_time: "",
    content_end_date: "",
}

type formPollChoice = {
    form_poll_choice: string, id_form_poll_choice: number | null, count?: number
}
export const ManageStateDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();



    const [formState, setFormState] = useState<bodyFormPoll>({
        is_public: false,
        form_poll_public_start: "",
        form_poll_end_time: moment().add(10, 'year').format("HH:mm"),
        form_poll_name: "",
        form_poll_public_start_time: "",
        form_poll_public_end_time: moment().add(10, 'year').format("YYYY-MM-DD"),
        id_media_file: null,
        form_poll_choice: [],
        form_poll_desc: "",
        form_poll_end: "",
        form_poll_public_end: "",
        form_poll_start: "",
        id_poll_type: null,
        is_draft: false
    })
    const [errorMessage, setErrorMessage] = useState<{
        content_start_date: string;
        content_end_time: string;
        content_name: string;
        content_start_time: string;
        content_end_date: string;
    }>(initialErrorMessage)
    const [image_upload, set_image_upload] = useState<File[]>([]);
    const [file_api_url, set_file_api_url] = useState<string>("");
    const [showModal, setShowModal] = useState<string>("")
    const [id_media_file, set_id_media_file] = useState<number | null>(null);
    const [content_no, set_content_no] = useState<string>("");

    const [image_api, set_image_api] = useState<any[]>([]);
    const [poll_type_data, set_poll_type_data] = useState<any[]>([]);
    const [id_poll_type, set_id_poll_type] = useState<number | null>(null);
    const [search_poll_type, set_search_poll_type] = useState<string>("");
    const [status, set_status] = useState<string>("");

    const [form_poll_choice, set_form_poll_choice] = useState<formPollChoice[]>([])

    const [form_poll_choice_vote, set_form_poll_choice_vote] = useState<formPollChoice[]>([]);

    const handleChangeFormState = (field: keyof bodyFormPoll, value: any) => {
        clearErrorMessage();
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("");
    }
    const clearErrorMessage = () => {
        setErrorMessage(initialErrorMessage)
    }

    const handleChangeImageApi = (media_files: any[]) => {
        const media_files_data = media_files?.map((list) => {
            return {
                ...list,
                is_image: true
            }
        })
        set_image_api((prev) => ([...prev, ...media_files_data]))
    }
    const handleDeleteImageApi = (index: number) => {
        set_image_api((prev) => prev.filter((_, i) => i !== index))
    }


    const handleGetDetail = async (id_article: number) => {
        dispatch(setLoading());
        await FormPollApi.findOne(id_article).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data || null;
                // const media_file_data: any[] = data?.media_file || [];
                const form_poll_choice: any[] = data?.form_poll_choice || [];
                set_content_no(data?.content_no || "");
                if (data?.id_poll_type) {
                    set_id_poll_type(data?.id_poll_type);
                }
                if (data?.id_media_file) {
                    set_image_api([
                        {
                            is_image: true,
                            media_file_path: data?.media_file_path,
                            id_media_file: data?.id_media_file,
                            media_file_name: data?.media_file_name
                        }
                    ])
                }
                // if (media_file_data?.length > 0) {
                //     const image_data_media_file = media_file_data?.map((list) => {
                //         return {
                //             ...list,
                //             is_image: true
                //         }
                //     })
                //     set_image_api(image_data_media_file);
                // }
                if (data?.status) {
                    set_status(data?.status)
                }
                if (form_poll_choice?.length > 0) {
                    set_form_poll_choice(form_poll_choice)
                }
                setFormState((prev) => ({
                    ...prev,
                    ...data,
                    form_poll_start_time: data?.form_poll_start ? moment(data?.form_poll_start).format("HH:mm") : "",
                    form_poll_end_time: data?.form_poll_end ? moment(data?.form_poll_end).format("HH:mm") : "",
                    form_poll_public_start_time: data?.form_poll_public_start ? moment(data?.form_poll_public_start).format("HH:mm") : "",
                    form_poll_public_end_time: data?.form_poll_public_end ? moment(data?.form_poll_public_end).format("HH:mm") : "",
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetPollType = async () => {
        await FormPollApi.dropdownPollType().then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || [];
                set_poll_type_data(data_value)
            }
        }).catch((err) => err)
    }

    const handleAddPollVote = () => {
        const new_poll: formPollChoice = {
            form_poll_choice: "",
            id_form_poll_choice: null
        }
        set_form_poll_choice((prev) => ([...prev, new_poll]))
    }
    const handleRemovePollVote = (index: number) => {
        set_form_poll_choice((prev) => prev.filter((_, i) => i !== index));
    }
    const handleChangeFormPoll = <T extends keyof formPollChoice>(field: T, value: formPollChoice[T], index: number) => {
        set_form_poll_choice((prev) =>
            produce(prev, (draft) => {
                if (draft[index]) {
                    draft[index][field] = value;
                }
            })
        );
    };
    const handleGetChartData = async (id_form_poll: number) => {
        await FormPollApi.chartData(id_form_poll).then((res) => {
            if (res.status < 300) {
                const data_value: any[] = res.data?.data || [];
                set_form_poll_choice_vote(data_value?.map((list) => {
                    return {
                        form_poll_choice: list?.name,
                        id_form_poll_choice: list?.id_form_poll_choice,
                        count: +list?.count || 0
                    }
                }))
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const generateForm = (status: string, is_public?: number): bodyFormPoll => {
        const start_date_public: string | null = formState.form_poll_public_start
            ? moment(
                `${moment(formState.form_poll_public_start).format("YYYY-MM-DD")}${formState.form_poll_public_start_time ? ` ${formState.form_poll_public_start_time}` : ''}`
            ).format(formState.form_poll_public_start_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";

        const end_date_public: string | null = formState.form_poll_public_end
            ? moment(
                `${moment(formState.form_poll_public_end).format("YYYY-MM-DD")}${formState.form_poll_public_end_time ? ` ${formState.form_poll_public_end_time}` : ''}`
            ).format(formState.form_poll_public_end_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";
        const start_date_vote: string | null = formState.form_poll_start
            ? moment(
                `${moment(formState.form_poll_start).format("YYYY-MM-DD")}${formState.form_poll_start_time ? ` ${formState.form_poll_start_time}` : ''}`
            ).format(formState.form_poll_start_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";

        const end_date_vote: string | null = formState.form_poll_end
            ? moment(
                `${moment(formState.form_poll_end).format("YYYY-MM-DD")}${formState.form_poll_end_time ? ` ${formState.form_poll_end_time}` : ''}`
            ).format(formState.form_poll_end_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";
        return {
            is_public: is_public ? !!is_public : !!formState.is_public,
            form_poll_choice: form_poll_choice?.filter((x) => x.form_poll_choice)?.map((list) => {
                return {
                    form_poll_choice: list.form_poll_choice,
                    id_form_poll_choice: list?.id_form_poll_choice,
                    form_poll_choice_type: FORM_POLL_CHOICE_TYPE.NORMAL
                }
            }),
            form_poll_desc: "",
            form_poll_end: end_date_vote,
            form_poll_name: formState.form_poll_name,
            form_poll_public_end: end_date_public,
            form_poll_public_start: start_date_public,
            form_poll_start: start_date_vote,
            id_media_file: image_api?.length > 0 ? image_api?.find((x) => x)?.id_media_file : null,
            id_poll_type: id_poll_type,
            is_draft: status === STATUS_ENUM.DRAFT,
        }
    }
    const validate_data = (accept?: boolean): boolean => {
        let is_not_valid: boolean = false;
        if (!formState.form_poll_public_start) {
            setErrorMessage((prev) => ({ ...prev, content_start_date: "ระบุวันที่เริ่มต้นเผยแพร่" }))
            is_not_valid = true
        }
        if (!formState.form_poll_public_end) {
            setErrorMessage((prev) => ({ ...prev, content_end_date: "ระบุวันที่สิ้นสุดเผยแพร่" }))
            is_not_valid = true
        }
        if (!formState.form_poll_public_start_time) {
            setErrorMessage((prev) => ({ ...prev, content_start_time: "ระบุเวลาที่เริ่มต้นเผยแพร่" }))
            is_not_valid = true
        }
        if (!formState.form_poll_public_end_time) {
            setErrorMessage((prev) => ({
                ...prev, content_end_time: "ระบุเวลาที่สิ้นสุดเผยแพร่"
            }))
            is_not_valid = true
        }
        if (!formState.form_poll_name) {
            setErrorMessage((prev) => ({
                ...prev, content_end_time: "ระบุชื่อโพลโหวต"
            }))
            is_not_valid = true
        }
        // if (!formState.content_name) {
        //     setErrorMessage((prev) => ({ ...prev, content_name: "ระบุชื่อโพลโหวต" }))
        //     is_not_valid = true
        // }
        return is_not_valid
    }
    const handleSubmit = async (mode: "DRAFT" | "SUBMIT") => {
        const body = generateForm(mode === 'DRAFT' ? STATUS_ENUM.DRAFT : STATUS_ENUM.ACTIVE, mode === 'SUBMIT' ? 1 : undefined);
        const is_not_valid = validate_data(mode === 'SUBMIT' ? true : false);
        if (is_not_valid) return;
        dispatch(setLoading());
        if (id) {
            await FormPollApi.update(+id, body).then((res) => {
                if (res.status < 300) {
                    if (mode === 'SUBMIT') {
                        navigate(-1);
                    } else {
                        handleGetDetail(+id);
                    }
                    alertSuccess("อัพเดตโพลโหวต", "อัพเดตโพลโหวต เรียบร้อยแล้ว")
                }
            }).catch((err) => {
                console.log(err)
                alertError("อัพเดตโพลโหวต", "อัพเดตโพลโหวต ไม่สำเร็จ")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await FormPollApi.create(body).then(async (res) => {
                if (res.status < 300) {
                    alertSuccess("เพิ่มโพลโหวต", "เพิ่มโพลโหวต เรียบร้อยแล้ว")
                    const id_content = res.data?.data?.id_content;
                    if (id_content) {
                        window.location.replace(routeName.cms_website.poll_vote_detail.replace(":id", id_content))
                    } else {
                        navigate(routeName.cms_website.poll_vote);
                    }
                }
            }).catch((err) => {
                console.log(err)
                alertError("เพิ่มโพลโหวต", "เพิ่มโพลโหวต ไม่สำเร็จ")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetPollType();
    }, [])

    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id);
            handleGetChartData(+id);
        }
    }, [])


    return {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        image_upload,
        id_media_file,
        set_image_upload,
        set_file_api_url,
        set_id_media_file,
        file_api_url,
        setShowModal,
        handleCloseModal,
        showModal,
        setFormState,
        image_api,
        handleChangeImageApi,
        handleDeleteImageApi,
        content_no,
        poll_type_data,
        set_search_poll_type,
        id_poll_type,
        set_id_poll_type,
        form_poll_choice,
        handleAddPollVote,
        handleRemovePollVote,
        handleChangeFormPoll,
        form_poll_choice_vote,
        status

    }
}